import apiClient from "./APIClient";

export const createDownlineAgent = async (payload) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.post(
      `merchant-downlineAgent?lang=${lang}`,
      payload
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getDownlineAgents = async (parentUserId, filters = {}) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    let url = `merchant-downlineAgent/${parentUserId}?lang=${lang}`;
    

    const params = new URLSearchParams();
    
    if (filters.search) {
      params.append('search', filters.search);
    }
    if (filters.page) {
      params.append('page', filters.page);
    }
    if (filters.limit) {
      params.append('limit', filters.limit);
    }
    if (filters.status) {
      params.append('status', filters.status);
    }
    if (filters.accountType) {
      params.append('accountType', filters.accountType);
    }
    if (filters['commission_rate[gte]']) {
      params.append('commission_rate[gte]', filters['commission_rate[gte]']);
    }
    if (filters['commission_rate[lte]']) {
      params.append('commission_rate[lte]', filters['commission_rate[lte]']);
    }
    if (filters['createdAt[gte]']) {
      params.append('createdAt[gte]', filters['createdAt[gte]']);
    }
    if (filters['createdAt[lte]']) {
      params.append('createdAt[lte]', filters['createdAt[lte]']);
    }
    
    if (params.toString()) {
      url += `&${params.toString()}`;
    }
    
    const res = await apiClient.get(url);
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const getAgentById = async (id) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(
      `merchant-downlineAgent/agent/${id}?lang=${lang}`
    );
    console.log(res, "this is res data")
    return res.data?.data;
  } catch (error) {
    throw error;
  }
};
export const updateAgentDetails = async (id, payload) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.patch(
      `merchant-downlineAgent/${id}?lang=${lang}`,
      payload
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const signUpAgent = async (payload) => {
  const lang = localStorage.getItem("i18nextLng");
  
  try {
    const formData = new FormData();
    


    formData.append('email', payload.email);
    formData.append('mobileNumber', payload.mobileNumber);
    formData.append('alternativeContact', payload.alternativeContact || '');
    formData.append('country', payload.country);
    formData.append('province', payload.province);
    formData.append('district', payload.district);
    formData.append('address', payload.address);
    formData.append('messageLanguage', payload.messageLanguage);
    formData.append('status', payload.status || 'active');
    formData.append('accountType', payload.accountType || 'merchant');
    formData.append('registrationType', payload.registrationType || 'direct');
    formData.append('username', payload.username || `${payload.firstName} ${payload.lastName}`);
    formData.append('user_type', payload.user_type || 'agent');
    formData.append('permissions', JSON.stringify(payload.permissions || []));
    
   
    if (payload.profile_picture) {
 
      if (payload.profile_picture.startsWith('data:')) {
        const blob = await fetch(payload.profile_picture).then(r => r.blob());
        formData.append('file', blob, 'profile.jpg');
      } else {
        formData.append('file', payload.profile_picture);
      }
    }

    const res = await apiClient.post(
      `merchant/sign-up?lang=${lang}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDownlineAgent = async (id) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.delete(
      `merchant-downlineAgent/${id}?lang=${lang}`
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const setComission = async (agentId, data) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.patch(
      `merchant-downlineAgent/${agentId}/set-commission?lang=${lang}`,
      data
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};



export const getCurrentAgentProfile = async () => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(`agents/profile/me?lang=${lang}`);
    console.log(res, "this is resdfs")
    return res.data?.data;
  } catch (error) {
    throw error;
  }
};
export const generateAgentReport = async (filters) => {
  try {
    const response = await api.post('/agents/generate-report', filters);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAgentProfile = async (payload) => {
  const lang = localStorage.getItem("i18nextLng");
  
  try {
    const formData = new FormData();
    

    if (payload.username) formData.append('username', payload.username);
    if (payload.email) formData.append('email', payload.email);
    if (payload.mobileNumber) formData.append('mobileNumber', payload.mobileNumber);
    

    if (payload.country) formData.append('country', payload.country);
    if (payload.province) formData.append('province', payload.province);
    if (payload.district) formData.append('district', payload.district);
    if (payload.address) formData.append('address', payload.address);
    if (payload.alternativeContact) formData.append('alternativeContact', payload.alternativeContact);
    if (payload.messageLanguage) formData.append('messageLanguage', payload.messageLanguage);
    
    if (payload.profile_picture && payload.profile_picture instanceof File) {
      formData.append('profile_picture', payload.profile_picture);
    }

    const res = await apiClient.patch(
      `agents/profile/update?lang=${lang}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    return res.data;
  } catch (error) {
    throw error;
  }
};